import React, { Component } from "react";
import "../../styles/components/Sliders/SliderSmall.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import NextSlidersSmall from "./NextSlidersSmall";

const scrollNext = (range, element, direction) => {
  console.log(range);
  let diff = 20;
  if (range - 20 < 0) {
    diff = range;
  }
  if (range <= 0) {
    return;
  } else {
    if (direction === "right") {
      setTimeout(() => {
        element.scrollLeft += diff;
        range -= 20;
        scrollNext(range, element, direction);
      }, 5);
    } else {
      setTimeout(() => {
        element.scrollLeft -= diff;
        range -= 20;
        scrollNext(range, element, direction);
      }, 5);
    }
  }
};

const scroll = direction => {
  var element = document.getElementById("pageslide");

  scrollNext(window.innerWidth, element, direction);
};

class SliderSmall extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="slider-small-wrapper">
        <div className="scrollable-slide" id="pageslide">
          <div className="photo-small-section">
            <img
              src="http://ata.gov.al/wp-content/uploads/2018/10/ligjet.jpg"
              className="top-photo"
              alt=""
            />

            <a href>
              <div className="title-under">TItle</div>
            </a>
          </div>
          <NextSlidersSmall />
          <NextSlidersSmall />
          <NextSlidersSmall />
        </div>
        <div className="small-nevigation-sliders">
          <FaAngleLeft
            size={35}
            color={"rgb(68, 68, 68)"}
            onClick={() => {
              scroll("left");
            }}
            style={{ cursor: "pointer" }}
          />
          <div className="slider-page-number">1/6</div>

          <FaAngleRight
            size={35}
            color={"rgb(68, 68, 68)"}
            onClick={() => {
              scroll("right");
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
    );
  }
}
export default SliderSmall;
